
define('lib/require.text!../templates/eventLog.html',[],function () { return '<div data-bind="dropdown: \'event-log\'"></div>\r\n\r\n<h1>Event Log <span data-bind="newWindow: []"></span></h1>\r\n\r\n<ul data-bind="foreach: events">\r\n  <li data-bind="html: text"></li>\r\n</ul>\r\n';});

